import { ProductTypes } from '../products/product-types';
import { GeneralPartnerTypeEnum, UIStatesEnum } from '../../models';
import { DateColumnType } from '../../models/table-column.model';
import { PositionsActionsType } from '../ui-components/table/custom-table.enums';
import { VatRatesFlowEnum } from 'projects/workspace/src/app/shared/enums';

export interface PositionInfoListModel {
  currencyIsOriginal?: boolean;
  label: string;
  prop: string;
  type: PositionItemTypeEnum;
  forcedType?: PositionItemTypeEnum;
  controlType?: ControlTypeEnum;
  itemClass?: string;
  hideWithProductType?: ProductTypes[];
  hideWithProductTypeGrouping?: ProductTypes[];
  showWithUIState?: UIStatesEnum[];
  unitType?: string | boolean;
  inputDropdownType?: InputDropdownTypeEnum;
  suffix?: string;
  listItems?: {value: any; label: any; enable?: boolean}[];
  bindLabel?: string;
  bindValue?: string;
  disabled?: boolean;
  vatBlocked?: boolean;
  vatIso3?: string;
  vatGeneralPartnerType?: GeneralPartnerTypeEnum;
  vatOcrCountryIso3?: string;
  vatFlow?: VatRatesFlowEnum;
  valueClass?: string;
  controlClass?: string;
  suffixClass?: string;
  showWithDocumentStatus?: any[];
  currencyConversion?: boolean;
  showCondition?: boolean;
  currencyNegativeRow?: boolean;
  currencyPositiveRow?: boolean;
  currencySourceFormat?: boolean;
  isOptional?: boolean;
  hintId?: string;
  dateType?: DateColumnType;
  displayConditions?: DisplayConditionsModel[];
  showUnitOnly?: boolean;
  colorState?: string;
}

export interface DisplayConditionsModel {
  values: any[];
  prop: string;
  productType?: ProductTypes;
}

export interface ActionsReorderingPositionModel {
  actionType: PositionsActionsType;
  rowIndex: number;
  moveTo: number;
  row: any;
  rows?: any;
  top?: any;
  left?: any;
  returnData?: any;
}

export interface PositionsIndexModel {
  index: number;
  title: string | number;
}

export enum PositionItemTypeEnum {
  WITH_CONTROL,
  PRIMARY,
  NUMBER,
  CURRENCY,
  STATUS_LINE,
  PROFIT,
  WITH_DATE
}

export enum ControlTypeEnum {
  TEXTAREA,
  TEXT_EDITOR,
  INPUT_DROPDOWN,
  DROPDOWN,
  DATE,
  PROFIT,
  TOGGLE,
  VAT_RATE,
}

export enum InputDropdownTypeEnum {
  NUMBER,
  CURRENCY,
}
